import React from "react";
import { IListing } from "../../lib/Listing";
import { BiMap } from "react-icons/bi";
import { IconContext } from "react-icons";
import { VitalsIcons } from "./VitalsIcons";
import { Button, IButtonProps } from "../Button";
import { ILinkFunc } from "../../lib/util";

export enum ERateInterval {
  day = 'day',
  week = 'wk',
  month = 'mth',
  year = 'yr',
  night = 'nt',
}

export interface IRentalVitalsProps {
  composite?: boolean;
  locationIcon?: boolean;
  ratesInline?: boolean;
  rateInterval?: ERateInterval;
  className?: string;
  listing: IListing;
  linkFunc?: ILinkFunc;
  viewRatesLink?: string;
  requestInfoLink?: string;
  showRequestInfoButton?: boolean;
  showViewRatesButton?: boolean;
}

export const RentalVitals: React.FC<IRentalVitalsProps> = ({
  listing,
  className,
  ratesInline = false,
  rateInterval = ERateInterval.week,
  composite = false,
  locationIcon = true,
  linkFunc,
  viewRatesLink,
  requestInfoLink,
  showRequestInfoButton = true,
  showViewRatesButton = true,
}) => {

  const linkf = linkFunc || ((props) => <a {...props} />);

  var defaultRates = listing.rates && listing.rates.filter(rate => rate.type?.toUpperCase() != "WINTER" && rate.type?.toUpperCase() != "YEARLY")
  var winterRates = listing.rates && listing.rates.filter(rate => rate.type?.toUpperCase() == "WINTER")
  var yearlyRates = listing.rates && listing.rates.filter(rate => rate.type?.toUpperCase() == "YEARLY")

  return (
    <div
      className={`rental-vitals p-4 grid grid-cols-1 gap-5 md:grid-cols-2 items-center ${className}`}
    >
      <div className="flex flex-col items-center gap-3">
        <div className={`font-bold uppercase`}>{listing.address.street1}</div>
        <div
          className={`vitals-icons pb-3 px-3 flex gap-3 md:gap-7 text-3xl lg:text-5xl border-b`}
        >
          <IconContext.Provider
            value={{
              size: ".95em",
              className: "mr-1 inline align-bottom",
            }}
          >
            <VitalsIcons listing={listing} />
          </IconContext.Provider>
        </div>
        <div
          className={`whitespace-nowrap overflow-hidden text-ellipsis uppercase`}
        >
          {listing.address.city}
        </div>
      </div>
      <div className="flex flex-col items-center gap-2">
        {ratesInline && defaultRates && defaultRates.length > 0 && (
          <div>
            <span className="block text-sm uppercase text-center">{`Rate/${defaultRates[0].type}`}</span>
            <span className="block text-3xl text-center">{`$${defaultRates[0].price.toLocaleString()}/${Object.values(ERateInterval)[Object.keys(ERateInterval).indexOf(defaultRates[0].type as unknown as ERateInterval)]}`}</span>
          </div>
        )}
        {ratesInline && winterRates && winterRates.length > 0 && (
          <div>
            <span className="block text-sm uppercase text-center">{`Winter Rate`}</span>
            <span className="block text-3xl text-center">{`$${winterRates[0].price.toLocaleString()}/mth`}</span>
          </div>
        )}
        {ratesInline && yearlyRates && yearlyRates.length > 0 && (
          <div>
            <span className="block text-sm uppercase text-center">{`Yearly Rate`}</span>
            <span className="block text-3xl text-center">{`$${yearlyRates[0].price.toLocaleString()}/mth`}</span>
          </div>
        )}
        {ratesInline && !defaultRates?.length && !winterRates?.length && !yearlyRates?.length && (
          <div>
            <span className="contactRates">Inquire for rates.</span>
          </div>
        )}
        {showViewRatesButton && !ratesInline && (
          <Button
            line={true}
            icon={false}
            linkProps={{
              className: `view-rates-button rounded-none bg-transparent min-w-[280px] md:min-w-[380px] border-inherit text-inherit hover:text-inherit capitalize italic font-light`,
              href: viewRatesLink
            }}
            linkFunc={linkf}
          >
            View Rates
          </Button>
        )}
        {showRequestInfoButton && <Button
          line={true}
          icon={false}
          linkProps={{
            className: `request-info-button rounded-none bg-transparent min-w-[280px] md:min-w-[380px] border-inherit text-inherit hover:text-inherit capitalize italic font-light`,
            href: requestInfoLink
          }}
          linkFunc={linkf}
        >
          Request Information
        </Button>}
      </div>
    </div>
  );
};
